// extracted by mini-css-extract-plugin
module.exports = {"dropdownWishlist":"_3y74y","wishlistCards":"JNndz","cardWishlist":"_33CSJ","cardWishlistItem":"OBTkP","cardLink":"_1jTLZ"};